import { useMemo, useState } from "react";
import L from "leaflet";
import { Marker, useMapEvents } from "react-leaflet";
import places from "./places.json";

// Settlements and large land, sea and glacier names from LMI's IS 50V
// (ornefni_flakar), drawn in the app's own type. Each name appears from the
// zoom that matches LMI's own display scale for it.
const escape = (text) =>
  text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const iconFor = (place) =>
  L.divIcon({
    className: "aq-place-anchor",
    html: `<span class="aq-place aq-place--${place.kind}">${escape(place.name)}</span>`,
    iconSize: null,
  });

export const PlaceLabels = () => {
  const map = useMapEvents({ zoomend: () => setZoom(map.getZoom()) });
  const [zoom, setZoom] = useState(() => map.getZoom());

  const icons = useMemo(() => places.map(iconFor), []);

  return places.map((place, i) =>
    place.minZoom <= zoom ? (
      <Marker
        key={`${place.kind}-${place.name}`}
        position={[place.lat, place.lon]}
        icon={icons[i]}
        interactive={false}
        keyboard={false}
      />
    ) : null,
  );
};
